<template>
    <v-form @submit.prevent="printReport" ref="form">
        <v-card style="border-radius:4px;">
            <v-toolbar flat height="45px">
                <span class="font-weight-bold ">Payroll Reports</span>
                <v-spacer></v-spacer>
                <v-btn icon @click.native="closeDialog()" >
                    <v-icon >close</v-icon>
                </v-btn>
            </v-toolbar>
            <v-alert v-if="error" :value="true" color="error" icon="error" outline>
                {{errorMessage}}
            </v-alert>
            <v-card-text>
                <v-layout row wrap> 
                    <v-flex xs12 sm12 class="form-content">
                        <v-select
                            label="Select report"
                            :items="report_types_list"
                            :rules="[rules.required]" 
                            item-text="name"
                            item-value="code"
                            v-model="reportCode"       
                        ></v-select>
                    </v-flex>
                </v-layout>
                <v-layout row wrap v-if="selected_report!=null" > 
                    <v-flex xs12 sm12 class="form-content"> 
                        <div v-for="(item,index) in selected_report.notes" :key="index">
                            <v-alert :value="true" :color="item.type" :icon="item.type" outline >
                                <div v-html="item.note"></div>
                            </v-alert> 
                        </div>
                    </v-flex>
                </v-layout>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions height="45px">
                <v-spacer></v-spacer>
                <v-btn v-if="selected_report!=null" color="primary" type="submit" :loading="loading" style="margin-right:20px;">
                    <v-icon>{{selected_report.icon}}</v-icon>&nbsp;&nbsp;&nbsp;{{selected_report.action}}
                </v-btn>
            </v-card-actions>
        </v-card>

        <v-dialog v-model="dialogPreview" fullscreen hide-overlay transition="dialog-bottom-transition">
            <preview ref="refPdfPreviewComponet" :dialogPreview.sync="dialogPreview"></preview>
        </v-dialog>
    </v-form>
</template>
<script>

import payrollApi from '@/api/payroll'
import awsS3Helper from '@/helpers/aws-s3'
import AWSS3DocumentType from '@/constants/aws-s3-document-types'

export default {
    components: {
        'preview': () => import('@/components/FilePreview/Preview'),
    },
    data () {
        return {
            error: false,
            errorMessage: null,
            reportCode: null,
            loading: false,
            disabled: false,
            dialogPreview: false,
            report_types: [
                {
                    code: 'CONTROL1', 
                    file_type: 'XLSX', 
                    action: 'Export as XLSX',
                    name: 'Control Report', 
                    icon: 'fas fa-file-excel', 
                    every_cutoff: true, 
                    monthend_only: false, 
                    quarterend_only: false, 
                    notes: [
                        {
                            type: 'info',
                            note: 'Summary of payroll per employee in excel format.'
                        },
                        // {
                        //     type: 'info',
                        //     note: 'Only <b>Approved</b>, <b>Credited</b>, <b>Published</b> payroll will be included in the report.'
                        // },
                    ]
                },
                {
                    code: 'DEPOSIT1', 
                    file_type: 'PDF', 
                    action: 'Preview PDF',
                    name: 'Payroll Deposit Slip', 
                    icon: 'fas fa-file-pdf', 
                    every_cutoff: true, 
                    monthend_only: false, 
                    quarterend_only: false, 
                    notes: [
                        {
                            type: 'info',
                            note: 'Displays all employee payroll records and Net Pay for this cutoff period, including unapproved entries.'
                        },
                        {
                            type: 'warning',
                            note: '<b>IMPORTANT: </b>All payroll entries must be approved before printing the deposit slip.'
                        },
                    ]
                },
                {
                    code: 'BIR1601C', 
                    action: 'Preview PDF',
                    file_type: 'PDF', 
                    name: 'BIR 1601-C', 
                    icon: 'fas fa-file-pdf', 
                    every_cutoff: false, 
                    monthend_only: true, 
                    quarterend_only: false, 
                    notes: [
                        {
                            type: 'info',
                            note: '<b>BIR Form No. 1601-C</b> : Monthly Remittance Return of Income Taxes Withheld on Compensation.'
                        },
                        {
                            type: 'warning',
                            note: 'Only <b>Approved</b>, <b>Credited</b>, <b>Published</b> payroll will be included in the report.'
                        },
                        {
                            type: 'warning',
                            note: '<b>Approved</b> or <b>Adjustments Processed</b> annualization generated on this cutoff period will be included in the report.'
                        },
                    ]
                },
                {
                    code: 'BIR1603Q', 
                    file_type: 'PDF', 
                    action: 'Preview PDF',
                    name: 'BIR 1603-Q', 
                    icon: 'fas fa-file-pdf', 
                    every_cutoff: false, 
                    monthend_only: false, 
                    quarterend_only: true, 
                    notes: [
                        {
                            type: 'info',
                            note: '<b>BIR Form No. 1603-Q</b> : Quarterly Remittance Return of Final Income Taxes Withheld on Fringe Benefits paid to Employees other than Rank and File.'
                        },
                        {
                            type: 'warning',
                            note: 'Only <b>Approved</b>, <b>Credited</b>, <b>Published</b> payroll will be included in the report.'
                        },
                    ]
                },
            ],
            rules: {
                required: value => !!value || 'Required field'
            },
            employeeName: null,
            fiscalPeriodId: null,
            selectedUserId: null,
            cutoff: null,
        }
    },
    methods: {
        setParam(data) {
            this.$refs.form.reset()
            this.cutoff = data
        },
        async printReport() {
            try {
                if (this.$refs.form.validate()) {
                    if (this.reportCode=='CONTROL1') this.getControlReport()
                    if (this.reportCode=='BIR1601C') this.preview1601C()
                    if (this.reportCode=='BIR1603Q') this.preview1603Q()
                    if (this.reportCode=='DEPOSIT1') this.previewDepositSlip()
                }
            }catch(error){
                this.error = true
                this.errorMessage = error
            }
        },        
        closeDialog() {
            this.$emit('update:dialogReports', false)
        },
        async preview1603Q() {
            try {
                this.loading = true 
                const response = await payrollApi.get1603QUrl(this.selectedCutoffId)
                if (response && response.status == 200) {
                    var file = {
                        name: response.data.fileName,
                        type: 'Pdf',
                        url: response.data.url,
                        downloadUrl: awsS3Helper.getCompanyDocumentUrl(response.data.fileName, AWSS3DocumentType.BIR1603)
                    }
                    this.$refs.refPdfPreviewComponet.setParams(file)
                    this.loading = false
                    this.dialogPreview = true
                }
            }catch(error){
                this.error = true
                this.errorMessage = error
            }
        },
        async preview1601C() {
            try {
                this.loading = true 
                const response = await payrollApi.get1601CUrl(this.selectedCutoffId)
                if (response && response.status == 200) {
                    var file = {
                        name: response.data.fileName,
                        type: 'Pdf',
                        url: response.data.url,
                        downloadUrl: awsS3Helper.getCompanyDocumentUrl(response.data.fileName, AWSS3DocumentType.BIR1601)
                    }
                    this.$refs.refPdfPreviewComponet.setParams(file)
                    this.loading = false
                    this.dialogPreview = true
                }
            }catch(error){
                this.error = true
                this.errorMessage = error
            }
        },
        async getControlReport() {
            try {
                this.loading = true
                const response = await payrollApi.getControlReport(this.selectedCutoffId)
                
                var blob = new Blob([response.data], { type: 'application/vnd.ms-excel' })
                var link = document.createElement('a')
                link.href = window.URL.createObjectURL(blob)
                link.download = 'Control-Report-' + this.getCoverageDesc + '.xlsx'
                link.click()
                this.loading = false
            }catch(error){
                this.errorMessage = error
                this.error = true
            }
        },
        async previewDepositSlip() {
            try {
                this.loading = true 
                const response = await payrollApi.getPayrollDepositSlipUrl(this.selectedCutoffId)
                if (response && response.status == 200) {
                    var file = {
                        name: response.data.fileName,
                        type: 'Pdf',
                        url: response.data.url,
                        downloadUrl: awsS3Helper.getCompanyDocumentUrl(response.data.fileName, AWSS3DocumentType.DepositSlips)
                    }
                    this.$refs.refPdfPreviewComponet.setParams(file)
                    this.loading = false
                    this.dialogPreview = true
                }
            }catch(error){
                this.error = true
                this.errorMessage = error
            }
        },
    },
    created() {},
    computed: {
        selected_report() {
            if (this.reportCode!=null){
                return this.report_types.filter(x => {
                    return x.code == this.reportCode
                })[0]
            }
        },
        selectedCutoffId() {
            if (this.cutoff!=null) return this.cutoff.cutoffId
        },
        IsMonthEndClosing() {
            if (this.cutoff!=null) return this.cutoff.isMonthEndClosing
        },
        isQuarterEndClosing() {
            if (this.cutoff!=null) return this.cutoff.isQuarterEndClosing
        },
        fiscalYear() {
            if (this.cutoff!=null) return this.cutoff.fiscalYear
        },
        cutoffMonth() {
            if (this.cutoff!=null) return this.$moment(this.cutoff.cutoffEnd).format('MMM')
        },
        report_types_list() {
            var reports = this.report_types.filter(x => {
                return (
                        (x.every_cutoff == true) ||
                        (x.every_cutoff == false && this.IsMonthEndClosing == true && x.monthend_only == this.IsMonthEndClosing) ||
                        (x.every_cutoff == false && this.isQuarterEndClosing == true && x.quarterend_only == this.isQuarterEndClosing)
                )
            })
            return reports
        },
        getCoverageDesc() {
            return this.$moment(this.cutoff.cutoffStart).format('YYYY-MM-DD') + ' - ' + this.$moment(this.cutoff.cutoffEnd).format('YYYY-MM-DD')
        },
    }
}
</script>
<style scoped>
.form-content {
    padding: 0px 15px 0px 15px;
}
</style>